import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

export const appSelector = {
	selectName: createSelector(
		(state: RootState) => state.app.name,
		(res) => res,
	),
	selectKana: createSelector(
		(state: RootState) => state.app.kana,
		(res) => res,
	),
	selectPrev: createSelector(
		(state: RootState) => state.app.prev,
		(res) => res,
	),
	selectNext: createSelector(
		(state: RootState) => state.app.next,
		(res) => res,
	),
	selectAlphabet: createSelector(
		(state: RootState) => state.app.alphabet,
		(res) => res,
	),
};
